import backgroundImage from "../../custom/assets/background.jpg"

const backgroundStyle={
  content:"",
  position: 'fixed',
  top:0,
  left:0,
  bottom:0,
  right:0,
  width:'100%',
  height:'100%',
  backgroundImage:`url(${backgroundImage})`,
  backgroundSize:'cover',
  backgroundPosition:'center',
  opacity:0.1,
  zIndex:-1,
}

function Background(){
    return (<div style={backgroundStyle}></div>);
}

export default Background;